import React from 'react';
import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
} from 'react-admin';


import {
  isRequired,
  isPostiveDecimal,
} from '../../validators';


export default props => (
  <Create
    {...props}
    title="Create Offer Order"
  >
    <SimpleForm>
      <ReferenceInput
        label="Offer"
        source="offerId"
        reference="offerings"
        filter={{ isExternalOffer: 0 }}
        validate={isRequired}
        perPage={100}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Account"
        source="accountNumber"
        reference="accounts"
        validate={isRequired}
        perPage={100}
      >
        <SelectInput optionText="id" />
      </ReferenceInput>
      <TextInput
        source="requestedTotalCurrencyAmt"
        validate={isPostiveDecimal}
      />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/OfferOrder/Create.js